import React, { FunctionComponent } from "react";

import { Layout } from "./blocks/Layout/Layout";
import { DealerRoutes } from "./navigation/DealerRoutes";
import { Toast } from "./ui/Toast/Toast";

export const DealerApplication: FunctionComponent = () => {
  return (
    <Layout>
      <DealerRoutes />
      <Toast />
    </Layout>
  );
};
